/* ═══════════════════════════════════════════════════════════════
   Shared numeric / format helpers for the Team Performance page
   and its chart components. Pure functions, no React.
   ═══════════════════════════════════════════════════════════════ */

export function num(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

export function pct(n, d) {
  return d > 0 ? +((n * 100) / d).toFixed(2) : 0;
}

export function clamp(v, min = 0, max = 100) {
  const n = Number(v);
  if (!Number.isFinite(n)) return min;
  return Math.max(min, Math.min(max, n));
}

/* Format a number to a fixed number of decimals, or "-" when not finite. */
export function fmt(v, digits = 1) {
  const n = Number(v);
  return Number.isFinite(n) ? n.toFixed(digits) : "-";
}
